import { create } from "zustand";

export const useTransactionTrackingStore = create((set) => ({
  activeTransactions: [],

  setActiveTransactions: (transactions) =>
    set({ activeTransactions: transactions }),

  updateTransaction: (transaction) =>
    set((state) => {
      const index = state.activeTransactions.findIndex(
        (tx) => tx._id === transaction._id
      );
      if (index >= 0) {
        // Update existing
        const updated = [...state.activeTransactions];
        updated[index] = { ...updated[index], ...transaction };
        return { activeTransactions: updated };
      }
      // Add new at the beginning
      return {
        activeTransactions: [transaction, ...state.activeTransactions].slice(
          0,
          10
        ),
      };
    }),

  removeTransaction: (txId) =>
    set((state) => ({
      activeTransactions: state.activeTransactions.filter(
        (tx) => tx._id !== txId
      ),
    })),
}));
